import React from "react";

import Header from "../Components/Header/Header";

function About() {
  return (
    <div>
      <Header />
    </div>
  );
}

export default About;
